import React, { useEffect, useState, useContext } from 'react';
import StorageEnum from '../enums/StorageEnum';
import Storage from '../utils/Storage';
import { createContext } from 'react';
import axios from 'axios';

// User context
export const AuthContext = createContext({});

// User Context Provider
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [cotation, setCotation] = useState("-");

  async function getUser() {
    try {
      const storageUser = await Storage.getItem(StorageEnum.USER);

      if (storageUser) {
        setUser(storageUser);
      } else {
        setUser(null);
      }
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  async function loadCotation() {
    const response = await axios.get(
      `https://api.coingecko.com/api/v3/simple/price?ids=tether&vs_currencies=brl`,
      {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        crossDomain: true,
      }
    );

    setCotation(response.data.tether.brl);
  }

  useEffect(() => {
    getUser();
    loadCotation()

    setTimeout(loadCotation, 600000);
  }, []);

  async function logIn() {
    const storageUser = await Storage.getItem(StorageEnum.USER);

    setUser(storageUser);
  }

  async function logOut() {
    setUser(null);
    await Storage.removeItem(StorageEnum.USER);
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        cotation,
        loading,
        logOut,
        logIn,
        getUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

// Hook to consume the user context
export function useUser() {
  const context = useContext(AuthContext);

  return context;
}
